"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSuffix = exports.StyledHeadingText = exports.StyledHeading = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var StyledHeading = _styledComponents["default"].h1.withConfig({
  displayName: "Headingstyles__StyledHeading",
  componentId: "sc-c4er8u-0"
})(["", " ", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  flex items-start lh-title mb0\n  ", "\n  ", "\n  ", "\n"])), function (_ref) {
  var centered = _ref.centered;
  return centered && 'flex justify-center';
}, function (_ref2) {
  var _heading$type;

  var _ref2$theme$heading = _ref2.theme.heading,
      heading = _ref2$theme$heading === void 0 ? {} : _ref2$theme$heading,
      type = _ref2.type;
  return (_heading$type = heading[type]) === null || _heading$type === void 0 ? void 0 : _heading$type.container;
}, function (_ref3) {
  var _ref3$theme$heading$f = _ref3.theme.heading.font,
      font = _ref3$theme$heading$f === void 0 ? {} : _ref3$theme$heading$f,
      as = _ref3.as;
  return font === null || font === void 0 ? void 0 : font.tachyons[as];
}), function (_ref4) {
  var _ref4$theme$heading$f = _ref4.theme.heading.font,
      font = _ref4$theme$heading$f === void 0 ? {} : _ref4$theme$heading$f,
      as = _ref4.as;
  return font === null || font === void 0 ? void 0 : font.manual[as];
});

exports.StyledHeading = StyledHeading;

var StyledHeadingText = _styledComponents["default"].span.withConfig({
  displayName: "Headingstyles__StyledHeadingText",
  componentId: "sc-c4er8u-1"
})(["", " border-width:0.1em;margin-bottom:-1px;& span:first-child{", "}"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  dib pb1 black lh-title\n  ", "\n  ", "\n  "])), function (_ref5) {
  var _heading$type2;

  var _ref5$theme$heading = _ref5.theme.heading,
      heading = _ref5$theme$heading === void 0 ? {} : _ref5$theme$heading,
      type = _ref5.type;
  return (_heading$type2 = heading[type]) === null || _heading$type2 === void 0 ? void 0 : _heading$type2.text;
}, function (_ref6) {
  var headline = _ref6.headline;
  return headline && "f-".concat(headline);
}), (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["pr1"]))));

exports.StyledHeadingText = StyledHeadingText;

var StyledSuffix = _styledComponents["default"].span.withConfig({
  displayName: "Headingstyles__StyledSuffix",
  componentId: "sc-c4er8u-2"
})(["", " font-size:0.65em;"], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["fw4 dib lh-solid pt1"]))));

exports.StyledSuffix = StyledSuffix;